import { computed } from "vue";
import { useNgSession } from "@allwyn/ng/ng-session";
import { useLocalStorage, useSessionStorage } from "@allwyn/storage/composables/use-storage";

// RULES:
// 1) If closed, dont show again
// 2) Show only once per session
// 3) Show only 3 times, if user dont open / close it
export const useFloatingDisplay = (analyticsCodeName: string, loggedIn: "" | "not-logged-in" | "logged-in") => {
    const cookieKey = `floating-${analyticsCodeName}`;
    const cookieClosedKey = `floating-${analyticsCodeName}-closed`;
    const localStorage = useLocalStorage();
    const sessionStorage = useSessionStorage();
    const { isLoggedIn } = useNgSession();
    // logged-in rule
    const showBasedOnLoggedState = computed(() => {
        const doNotShow =
            (isLoggedIn.value && loggedIn === "not-logged-in") || (!isLoggedIn.value && loggedIn === "logged-in");
        return !doNotShow;
    });

    function shouldShow(dryRun = false): boolean {
        // rule 1
        const rule1Value = localStorage.getItem(cookieClosedKey);
        if (rule1Value) {
            return false;
        }

        // rule 2
        const rule2Value = sessionStorage.getItem(cookieKey);
        if (rule2Value) {
            return false;
        }
        if (!dryRun) sessionStorage.setItem(cookieKey, "true", "essential");

        // rule 3
        const rule3Value = localStorage.getItem(cookieKey);
        let displayedCount = rule3Value ? parseInt(rule3Value) : 0;
        if (isNaN(displayedCount)) {
            displayedCount = 0;
        }
        if (displayedCount >= 3) {
            return false;
        }
        displayedCount++;
        if (!dryRun) localStorage.setItem(cookieKey, displayedCount.toString(), "essential");

        return true;
    }

    function closed() {
        localStorage.setItem(cookieClosedKey, "true", "essential");
    }

    return {
        shouldShow,
        closed,
        showBasedOnLoggedState,
    };
};
